import React, { useEffect, useState } from 'react';
import CategoriesList from './../CategoriesList';
import { useTranslation } from 'react-i18next';
import { useChangeProfileSettingsMutation } from '../../../../features/master/masterApiSlice';
import Modal from './../../../HeaderContainer/Popup/Modal';
import Success from '../Success';

const ProfileSettings = ({ categories, tagLine, description }) => {
    const { t } = useTranslation();
    const [changeProfileSettings] = useChangeProfileSettingsMutation();
    const [masterCategories, setMasterCategories] = useState([]);
    const [newTagLine, setNewTagLine] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setMasterCategories(Array.isArray(categories) ? categories : []);
        setNewTagLine(tagLine || '');
        setNewDescription(description || '');
    }, [categories, tagLine, description]);

    const onSubmit = async e => {
        e.preventDefault();
        setErrorMessage('');
        setIsSaving(true);

        try {
            const result = await changeProfileSettings({ masterCategories, newTagLine, newDescription }).unwrap();

            if (result?.success !== true) throw new Error('Could not change profile settings');

            setMasterCategories(result.categories || []);
            setNewTagLine(result.tagLine || '');
            setNewDescription(result.description || '');
            setIsOpen(true);
        } catch (error) {
            setErrorMessage(t('CouldNotUpdateProfile'));
        } finally {
            setIsSaving(false);
        }
    }

    return <div className="col-xl-12">
        <div className="dashboard-box">

            <div className="headline">
                <h3><i className="icon-material-outline-face"></i> {t("MyProfile")}</h3>
            </div>

            <div className="content">
                <form onSubmit={onSubmit}>
                    <ul className="fields-ul">
                        <li>
                            <div className="row">
    
                                <div className="col-xl-4">
                                    <div className="submit-field">
                                        <h5>{t("Categories")} {false && <i className="help-icon" data-tippy-placement="right" title="Add up to 10 categories"></i>}</h5>
    
                                        <CategoriesList setMasterCategories={setMasterCategories} categories={masterCategories} />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="submit-field">
                                        <h5>{t('Tagline')}</h5>
                                        <input type="text" className="" maxLength="100" value={newTagLine} onChange={e => setNewTagLine(e.target.value)} />
                                    </div>
                                </div>
    
                                <div className="col-xl-12">
                                    <div className="submit-field">
                                        <h5>{t('IntroduceYourself')}</h5>
                                        <textarea cols="30" rows="5" name="description" className="with-border" maxLength="255" onChange={e => setNewDescription(e.target.value)}
                                            value={newDescription}
                                        ></textarea>
                                    </div>
                                </div>
    
                            </div>
                        </li>
    
                        <li>
                            <div className="row">
                                <div className="col-xl-4">
                                    <button type='submit' disabled={isSaving} className='button ripple-effect margin-bottom-20'>{isSaving ? t('Saving') : t("SaveProfileChanges")}</button>
                                    {errorMessage && <div className="notification error closeable margin-bottom-20">{errorMessage}</div>}
                                </div>
                            </div>
                        </li>
                    </ul>
                </form>
                <Modal tabs={[t('Success')]} open={isOpen}>
                    <Success mainText={t('YourDataHasBeenSuccessfullyUpdated')} onClose={() => setIsOpen(false)} />
                </Modal>
            </div>
        </div>
    </div>;
};

export default ProfileSettings;
